import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import dompurify from 'dompurify';
import { Tooltip } from 'primereact/tooltip';
import { isFunction } from 'lodash';

export default class WrappedTooltip extends Component {
	renderContent() {
		const { tooltip, children } = this.props;

		if (isString(tooltip)) {
			// string content
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: dompurify.sanitize(tooltip),
					}}
				/>
			);
		} else if (isFunction(tooltip)) {
			// functional component
			return tooltip();
		} else if (children) {
			// custom content by using JSX elements
			return isString(children) ? (
				<div
					dangerouslySetInnerHTML={{
						__html: dompurify.sanitize(children),
					}}
				/>
			) : (
				children
			);
		}

		return null;
	}

	render() {
		const { className, target, ...rest } = this.props;
		const content = this.renderContent();

		if (content) {
			return (
				<Tooltip
					className={classNames('common-ui-overlay-tooltip', {
						[className]: isString(className),
					})}
					target={isString(target) || isNumber(target) ? `.${target}` : null}
					data-qa="ui-tooltip"
					dataqa="ui-tooltip"
					{...rest}
				>
					{content}
				</Tooltip>
			);
		}

		return null;
	}
}

/**
 * Please refer to the official documentation for the rest props.
 * https://www.primefaces.org/primereact/tooltip/
 */
WrappedTooltip.propTypes = {
	tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};
